import { createOptionBindings } from '@ff-os/pdp-shared-redux/slices/sceneSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftSceneOptions } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';

const { createOptionSelector } = createOptionBindings<GiftSceneOptions, GiftPdpState>();

export const selectSceneWidth = createOptionSelector(o => o.width);
export const selectSceneHeight = createOptionSelector(o => o.height);
export const selectPrefabBackgroundAlpha = createOptionSelector(o => o.prefabBackgroundAlpha ?? 0.2);
export const selectPrefabPreviewMode = createOptionSelector(o => o.prefabPreviewMode);
export const selectPrefabColumnWidths = createOptionSelector(o => o.prefabColumnWidths ?? {});
export const selectPrefabHeading = createOptionSelector(o => o.prefabHeading ?? 'layouts');
export const selectIfPrefabsFitAllVariants = createOptionSelector(o => o.prefabsFitAllVariants);
export const selectPrefabWindowLayout = createOptionSelector(o => o.prefabWindowLayout ?? 'landscape');
export const selectContentFirst = createOptionSelector(o => o.contentFirst ?? false);